import { render, staticRenderFns } from "./InstantDelivery.vue?vue&type=template&id=19a18b9e&scoped=true&"
import script from "./InstantDelivery.vue?vue&type=script&lang=js&"
export * from "./InstantDelivery.vue?vue&type=script&lang=js&"
import style0 from "./InstantDelivery.vue?vue&type=style&index=0&id=19a18b9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a18b9e",
  null
  
)

export default component.exports